import { USER_TYPE } from "../constants";

import type { UserType } from "../constants";
import type { User } from "../models/User";

export function getUserType(user: Partial<User>): UserType {
  if (user.voltEmployee) {
    return USER_TYPE.VOLT_ADMIN;
  }

  if (user.owner) {
    return USER_TYPE.OWNER;
  }

  return USER_TYPE.STANDARD_USER;
}
